import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import styles from '../../../Products.module.scss'

import CopyButton from 'components/elements/buttons/CopyButton'
import ResultBlock from 'components/elements/blocks/ResultBlock'
import CustomButton from '../../../../../elements/buttons/CustomButton'

import { selectProxyCheckerLoading } from 'store/service/selectors'

interface ICurlResultProps {
  result: string
  activeSessionLengthType: any
  onGenerateIpClick: () => void
  onCheckProxyConnection: () => void
}

const CurlResult: React.FC<ICurlResultProps> = (props) => {
  const { result, activeSessionLengthType, onGenerateIpClick, onCheckProxyConnection } = props

  const proxyCheckerLoading = useSelector(selectProxyCheckerLoading)

  const [gettingNewIpLoaderStatus, toggleGettingNewIpLoader] = useState(false)

  const handleGenerateIp = () => {
    toggleGettingNewIpLoader(true)
    setTimeout(() => toggleGettingNewIpLoader(false), 300)

    onGenerateIpClick()
  }

  const handleCheckProxy = () => {
    onCheckProxyConnection()
  }

  return (
    <div>
      <div className={styles.resultNotice}>
        Select for command line or API connections, running proxy requests
        directly with cURL. Copy this request and paste it into Command Line
        (Windows) or Terminal (macOS/Linux):
      </div>

      <div className={styles.controls}>
        <CopyButton className={styles.rowBtn} size={'m'} text={result}>
          Copy URL
        </CopyButton>

        <CustomButton
          className={styles.rowBtn}
          color={'outline'}
          onClick={handleGenerateIp}
          loading={gettingNewIpLoaderStatus}
          disabled={activeSessionLengthType === 'new'}
        >
          Get new IP
        </CustomButton>

        <CustomButton
          className={styles.rowBtn}
          color={'outline'}
          loading={proxyCheckerLoading}
          onClick={handleCheckProxy}
        >
          Check proxy connection
        </CustomButton>
      </div>

      <ResultBlock className={styles.resultBlock}>{result}</ResultBlock>

      {/*<InputGroup
        labelTop={'A successfully completed request looks like this:'}
      >
        <div className={styles.resultExample}>
          {
            '{"status":true,"reason":"","data":{"carrier":"","city":"Melbourne","country_code":"US","country_name":"United States","ip":"97.102.236.127","isp":"Spectrum","region":"Florida"}}  '
          }
        </div>
      </InputGroup>*/}
    </div>
  )
}

export default CurlResult
